module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/105.a559f4a2.png";